import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ImperialPipeModule } from '../../../../core/pipes/imperial.pipe';
import { TakeOffAdditionalMeasurements, TakeOffMeasurement } from '../../domain';
import { TakeOffConfig } from '../feat-take-off-v2/domain';

@Component({
    selector: 'app-take-off-v2-drawings-info',
    templateUrl: './take-off-v2-drawings-info.component.html',
    styleUrls: ['./take-off-v2-drawings-info.component.scss'],
    standalone: false,
})
export class TakeOffV2DrawingsInfoComponent {
    // @ts-ignore TS2564
    @Input() config: TakeOffConfig;
    // @ts-ignore TS2564
    @Input() measurement: TakeOffMeasurement;

    @Output() additionalMeasurementsChanges = new EventEmitter<TakeOffAdditionalMeasurements>();

    constructor() {}

    public onSelectAdditionalMeasurements() {
        this.additionalMeasurementsChanges.emit(this.measurement.additionalMeasurements);
    }
}

@NgModule({
    declarations: [TakeOffV2DrawingsInfoComponent],
    imports: [CommonModule, FormsModule, ImperialPipeModule],
    exports: [TakeOffV2DrawingsInfoComponent],
})
export class TakeOffV2DrawingsInfoModule {}
